import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@strava/ui/Modal';
import { Button } from '@strava/ui/Button';
import I18n from 'utils/I18n';

import styles from './ConfirmModal.scss';

const ConfirmModal = ({ onDismiss, onConfirm, isOpen, title, body }) => {
  return (
    <Modal
      shouldRenderTriggerButton={false}
      open={isOpen}
      onOpenChange={(open) => !open && onDismiss()}
      shouldShowCloseButtonIcon={true}
      popupProps={{ className: styles.confirmModal }}
    >
      <Modal.Content>
        <Modal.Title className={styles.title}>{title}</Modal.Title>
        <Modal.Body className={styles.body}>{body}</Modal.Body>
        <Modal.Actions className={styles.actions}>
          <Button
            type="button"
            onClick={onDismiss}
            variant="text"
            className={styles.btn}
          >
            {I18n.t('components.button_cta_with_cancel.cancel')}
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            className={styles.btn}
            variant="primary"
          >
            {I18n.t('components.button_cta_with_cancel.confirm')}
          </Button>
        </Modal.Actions>
      </Modal.Content>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
};

export default ConfirmModal;
